/**
 * 프론트엔드 환경변수 설정
 */

interface Config {
  // API 설정
  API_BASE_URL: string
  API_TIMEOUT: number
  
  // 인증 설정
  TOKEN_KEY: string
  REFRESH_TOKEN_KEY: string
  
  // 파일 업로드 설정
  MAX_FILE_SIZE: number
  CHUNK_SIZE: number
  
  // UI 설정
  ITEMS_PER_PAGE: number
  DEBOUNCE_DELAY: number
}

const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_BASE_URL ||
  'http://localhost:8080/api'

const config: Config = {
  // API 설정
  API_BASE_URL: apiBaseUrl, 
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
  
  // 인증 설정
  TOKEN_KEY: 'access_token',
  REFRESH_TOKEN_KEY: 'refresh_token',
  
  // 파일 업로드 설정
  MAX_FILE_SIZE: parseInt(process.env.REACT_APP_MAX_FILE_SIZE || '10737418240'), // 10GB
  CHUNK_SIZE: parseInt(process.env.REACT_APP_CHUNK_SIZE || '8388608'), // 8MB
  
  // UI 설정
  ITEMS_PER_PAGE: parseInt(process.env.REACT_APP_ITEMS_PER_PAGE || '20'),
  DEBOUNCE_DELAY: parseInt(process.env.REACT_APP_DEBOUNCE_DELAY || '300'),
}

export default config
